import { dataHooks } from '@wix/data-hooks';

export const dishItemDataHooks = dataHooks<{
  root: {};
  image: {};
  title: {};
  description: {};
  price: {};
  discountLabel: {};
  labels: {};
  labelCounter: {};
  featuredBadge: {};
  cartBadge: {};
}>('dish-item');

export const DISH_IMAGE_SIZE = 300;
export const DISH_CARD_IMAGE_WIDTH = 560;
export const DISH_CARD_IMAGE_HEIGHT = 400;
